module.exports = __webpack_public_path__ + "img/appstore-sp.7cde3ada.svg";